import { render, staticRenderFns } from "./BudgetView.vue?vue&type=template&id=3b1fc7da&"
import script from "./BudgetView.vue?vue&type=script&lang=js&"
export * from "./BudgetView.vue?vue&type=script&lang=js&"
import style0 from "./BudgetView.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports